import Resource from '@/api/resources/Resource'

class SampleCodificationServices extends Resource {
    async getSampleCodifications(labId, caseId, sampleId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/codifications`)
        return response.data
    }
}

export default new SampleCodificationServices()
